import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { NoAuthGuard } from './common/guards/noAuth/no-auth.guard';
import { AuthGuard } from './common/guards/auth/auth.guard';
import { LoginPage } from './login/login.page';
import { InterventoAttivoGuard } from './compilazione-intervento/intervento-attivo.guard';
import { InterventoChiudibileGuard } from './compilazione-intervento/intervento-chiudibile.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginPage,
    canActivate: [NoAuthGuard],
  },
  {
    path: 'home',
    redirectTo: 'interventi',
    pathMatch: 'full'
  },
  {
    path: 'interventi',
    loadChildren: () => import('./interventi/interventi.module').then(m => m.InterventiPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'aziende',
    loadChildren: () => import('./aziende/aziende.module').then( m => m.AziendePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'settings',
    loadChildren: () => import('./settings/settings.module').then( m => m.SettingsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'download-anagrafiche',
    loadChildren: () => import('./download-anagrafiche/download-anagrafiche.module').then( m => m.DownloadAnagrafichePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'interventi/:idIntervento/riepilogo',
    loadChildren: () => import('./compilazione-intervento/compilazione-intervento.module').then( m => m.CompilazioneInterventoPageModule),
    canActivate: [AuthGuard, InterventoAttivoGuard]
  },
  {
    path: 'interventi/:idIntervento/chiudi',
    loadChildren: () => import('./chiusura-intervento/chiusura-intervento.module').then( m => m.ChiusuraInterventoPageModule),
    canActivate: [AuthGuard, InterventoAttivoGuard, InterventoChiudibileGuard]
  }

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
